// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SessionPicker — Phase 3 */

.SessionPicker_wrapper__ecnqB {
    position: relative;
    display: inline-block;
}

.SessionPicker_toggleBtn__vpho6 {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: var(--color-bg-secondary, #f3f4f6);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
    color: var(--color-text-muted, #6b7280);
    font-size: 12px;
    cursor: pointer;
    /* 색 전환은 부드럽게 — UI Conventions */
    transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease;
    white-space: nowrap;
    max-width: 320px;
}
.SessionPicker_toggleBtn__vpho6:hover:not(:disabled) {
    border-color: #3b82f6;
    color: var(--color-text, #1f2937);
}
.SessionPicker_toggleBtnBound__4hJpI {
    color: var(--color-text, #1f2937);
}
.SessionPicker_toggleBtnRunning__fcG9v {
    background: rgba(16, 185, 129, 0.08);
    border-color: rgba(16, 185, 129, 0.4);
    cursor: not-allowed;
}
.SessionPicker_toggleBtn__vpho6:disabled {
    cursor: not-allowed;
    opacity: 0.85;
}
.SessionPicker_label__7scNR {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}
.SessionPicker_runningElapsed__YbohB {
    font-size: 11px;
    color: #10b981;
    font-variant-numeric: tabular-nums;
    margin-left: 4px;
}
.SessionPicker_chevron__cZWNd {
    font-size: 12px;
    flex-shrink: 0;
}
.SessionPicker_catIcon__xtXdM {
    font-size: 12px;
    flex-shrink: 0;
}

/* Dropdown */
.SessionPicker_dropdown__OyyTy {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    min-width: 320px;
    max-width: 480px;
    max-height: 400px;
    overflow-y: auto;
    background: var(--color-bg-tertiary, #fff);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 6px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    z-index: 100;
    /* fade-in (UI Conventions: 120~200ms ease-out) */
    animation: SessionPicker_sp-fade-in__M1MsA 160ms ease-out;
}
@keyframes SessionPicker_sp-fade-in__M1MsA {
    from { opacity: 0; transform: translateY(-3px); }
    to   { opacity: 1; transform: translateY(0); }
}

.SessionPicker_group__Sd0Rm {
    padding: 4px 0;
}
.SessionPicker_groupTitle__VeGoX {
    font-size: 11px;
    font-weight: 600;
    color: var(--color-text-muted, #6b7280);
    padding: 6px 12px 4px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.SessionPicker_option__PwP42 {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    padding: 6px 12px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    color: var(--color-text, #1f2937);
    text-align: left;
    transition: background-color 120ms ease;
}
.SessionPicker_option__PwP42:hover {
    background: var(--color-hover, #f3f4f6);
}
.SessionPicker_optionCurrent__QumQl {
    background: rgba(59, 130, 246, 0.1);
    font-weight: 500;
}
.SessionPicker_optionLabel__8gZ3i {
    flex: 1 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}
.SessionPicker_optionSid__QXtUC {
    font-size: 10px;
    color: var(--color-text-muted, #9ca3af);
    flex-shrink: 0;
}
.SessionPicker_optionConn__uIduZ {
    font-size: 11px;
    color: var(--color-text-muted, #9ca3af);
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
}
.SessionPicker_optionStatus__1OOd4 {
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 8px;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}
.SessionPicker_status_idle__0FCOU       { background: #f3f4f6; color: #6b7280; }
.SessionPicker_status_running__vVtQL    { background: #d1fae5; color: #065f46; }
.SessionPicker_status_cancelling__b8hHi { background: #fef3c7; color: #92400e; }

.SessionPicker_empty__mJ\\+Os {
    padding: 14px 12px;
    color: var(--color-text-muted, #6b7280);
    font-size: 12px;
    line-height: 1.5;
}
.SessionPicker_empty__mJ\\+Os strong {
    color: var(--color-text, #1f2937);
}

.SessionPicker_projectFooter__VsBoY {
    padding: 8px 12px;
    border-top: 1px solid var(--color-border, #e5e7eb);
    background: var(--color-bg-secondary, #f9fafb);
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.SessionPicker_projectFooter__VsBoY small {
    font-size: 11px;
    color: var(--color-text-muted, #6b7280);
}
/* 다크 모드 */
[data-theme="dark"] .SessionPicker_toggleBtn__vpho6 {
    background: var(--color-bg-secondary);
    border-color: var(--color-border);
    color: var(--color-text-muted);
}
[data-theme="dark"] .SessionPicker_toggleBtnBound__4hJpI { color: var(--color-text); }
[data-theme="dark"] .SessionPicker_dropdown__OyyTy {
    background: var(--color-bg-tertiary);
    border-color: var(--color-border);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);
}
[data-theme="dark"] .SessionPicker_option__PwP42 { color: var(--color-text); }
[data-theme="dark"] .SessionPicker_option__PwP42:hover { background: var(--color-hover); }
[data-theme="dark"] .SessionPicker_status_idle__0FCOU { background: var(--color-bg-secondary); color: var(--color-text-muted); }

/* reduced-motion 가드 */
@media (prefers-reduced-motion: reduce) {
    .SessionPicker_toggleBtn__vpho6,
    .SessionPicker_option__PwP42 { transition: none; }
    .SessionPicker_dropdown__OyyTy { animation: none; }
}

/* 연결 유형 칩(개발·운영·교육 …) — 머리줄에서 옮겨 왔다. 색은 변수로만(다크모드는 밝은 색) */
.SessionPicker_connType__H40Co { display: inline-flex; align-items: center; gap: 4px; padding: 0 6px; border: 1px solid currentColor; border-radius: 10px;
  color: var(--conn-color); font-size: 11px; font-weight: 600; line-height: 16px; white-space: nowrap; flex-shrink: 0; }
.SessionPicker_connTypeDot__zBF55 { width: 6px; height: 6px; border-radius: 50%; background: var(--conn-color); }
[data-theme="dark"] .SessionPicker_connType__H40Co { color: var(--conn-color-dark, var(--conn-color)); }
[data-theme="dark"] .SessionPicker_connTypeDot__zBF55 { background: var(--conn-color-dark, var(--conn-color)); }
`, "",{"version":3,"sources":["webpack://./src/components/SessionPicker.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,8CAA8C;IAC9C,8CAA8C;IAC9C,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,kFAAkF;IAClF,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,0CAA0C;IAC1C,8CAA8C;IAC9C,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,iDAAiD;IACjD,yDAAoC;AACxC;AACA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,uCAAuC;AAC3C;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,cAAc;AAClB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;AACA,0CAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,0CAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,0CAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;IACI,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,kDAAkD;IAClD,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,uCAAuC;AAC3C;AACA,UAAU;AACV;IACI,qCAAqC;IACrC,iCAAiC;IACjC,8BAA8B;AAClC;AACA,2DAAsC,wBAAwB,EAAE;AAChE;IACI,oCAAoC;IACpC,iCAAiC;IACjC,yCAAyC;AAC7C;AACA,mDAA8B,wBAAwB,EAAE;AACxD,yDAAoC,8BAA8B,EAAE;AACpE,wDAAmC,qCAAqC,EAAE,8BAA8B,EAAE;;AAE1G,sBAAsB;AACtB;IACI;mCACU,gBAAgB,EAAE;IAC5B,iCAAY,eAAe,EAAE;AACjC;;AAEA,2DAA2D;AAC3D,iCAAY,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,8BAA8B,EAAE,mBAAmB;EAClI,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACvH,oCAAe,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AAC3F,qDAAyC,gDAAgD,EAAE;AAC3F,wDAA4C,qDAAqD,EAAE","sourcesContent":["/* SessionPicker — Phase 3 */\n\n.wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.toggleBtn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: var(--color-bg-secondary, #f3f4f6);\n    border: 1px solid var(--color-border, #d1d5db);\n    border-radius: 4px;\n    color: var(--color-text-muted, #6b7280);\n    font-size: 12px;\n    cursor: pointer;\n    /* 색 전환은 부드럽게 — UI Conventions */\n    transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease;\n    white-space: nowrap;\n    max-width: 320px;\n}\n.toggleBtn:hover:not(:disabled) {\n    border-color: #3b82f6;\n    color: var(--color-text, #1f2937);\n}\n.toggleBtnBound {\n    color: var(--color-text, #1f2937);\n}\n.toggleBtnRunning {\n    background: rgba(16, 185, 129, 0.08);\n    border-color: rgba(16, 185, 129, 0.4);\n    cursor: not-allowed;\n}\n.toggleBtn:disabled {\n    cursor: not-allowed;\n    opacity: 0.85;\n}\n.label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n}\n.runningElapsed {\n    font-size: 11px;\n    color: #10b981;\n    font-variant-numeric: tabular-nums;\n    margin-left: 4px;\n}\n.chevron {\n    font-size: 12px;\n    flex-shrink: 0;\n}\n.catIcon {\n    font-size: 12px;\n    flex-shrink: 0;\n}\n\n/* Dropdown */\n.dropdown {\n    position: absolute;\n    top: calc(100% + 4px);\n    right: 0;\n    min-width: 320px;\n    max-width: 480px;\n    max-height: 400px;\n    overflow-y: auto;\n    background: var(--color-bg-tertiary, #fff);\n    border: 1px solid var(--color-border, #d1d5db);\n    border-radius: 6px;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\n    z-index: 100;\n    /* fade-in (UI Conventions: 120~200ms ease-out) */\n    animation: sp-fade-in 160ms ease-out;\n}\n@keyframes sp-fade-in {\n    from { opacity: 0; transform: translateY(-3px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.group {\n    padding: 4px 0;\n}\n.groupTitle {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--color-text-muted, #6b7280);\n    padding: 6px 12px 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.option {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n    padding: 6px 12px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 12px;\n    color: var(--color-text, #1f2937);\n    text-align: left;\n    transition: background-color 120ms ease;\n}\n.option:hover {\n    background: var(--color-hover, #f3f4f6);\n}\n.optionCurrent {\n    background: rgba(59, 130, 246, 0.1);\n    font-weight: 500;\n}\n.optionLabel {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n.optionSid {\n    font-size: 10px;\n    color: var(--color-text-muted, #9ca3af);\n    flex-shrink: 0;\n}\n.optionConn {\n    font-size: 11px;\n    color: var(--color-text-muted, #9ca3af);\n    flex-shrink: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n}\n.optionStatus {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 8px;\n    flex-shrink: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n.status_idle       { background: #f3f4f6; color: #6b7280; }\n.status_running    { background: #d1fae5; color: #065f46; }\n.status_cancelling { background: #fef3c7; color: #92400e; }\n\n.empty {\n    padding: 14px 12px;\n    color: var(--color-text-muted, #6b7280);\n    font-size: 12px;\n    line-height: 1.5;\n}\n.empty strong {\n    color: var(--color-text, #1f2937);\n}\n\n.projectFooter {\n    padding: 8px 12px;\n    border-top: 1px solid var(--color-border, #e5e7eb);\n    background: var(--color-bg-secondary, #f9fafb);\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n.projectFooter small {\n    font-size: 11px;\n    color: var(--color-text-muted, #6b7280);\n}\n/* 다크 모드 */\n[data-theme=\"dark\"] .toggleBtn {\n    background: var(--color-bg-secondary);\n    border-color: var(--color-border);\n    color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .toggleBtnBound { color: var(--color-text); }\n[data-theme=\"dark\"] .dropdown {\n    background: var(--color-bg-tertiary);\n    border-color: var(--color-border);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);\n}\n[data-theme=\"dark\"] .option { color: var(--color-text); }\n[data-theme=\"dark\"] .option:hover { background: var(--color-hover); }\n[data-theme=\"dark\"] .status_idle { background: var(--color-bg-secondary); color: var(--color-text-muted); }\n\n/* reduced-motion 가드 */\n@media (prefers-reduced-motion: reduce) {\n    .toggleBtn,\n    .option { transition: none; }\n    .dropdown { animation: none; }\n}\n\n/* 연결 유형 칩(개발·운영·교육 …) — 머리줄에서 옮겨 왔다. 색은 변수로만(다크모드는 밝은 색) */\n.connType { display: inline-flex; align-items: center; gap: 4px; padding: 0 6px; border: 1px solid currentColor; border-radius: 10px;\n  color: var(--conn-color); font-size: 11px; font-weight: 600; line-height: 16px; white-space: nowrap; flex-shrink: 0; }\n.connTypeDot { width: 6px; height: 6px; border-radius: 50%; background: var(--conn-color); }\n:global([data-theme=\"dark\"]) .connType { color: var(--conn-color-dark, var(--conn-color)); }\n:global([data-theme=\"dark\"]) .connTypeDot { background: var(--conn-color-dark, var(--conn-color)); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SessionPicker_wrapper__ecnqB`,
	"toggleBtn": `SessionPicker_toggleBtn__vpho6`,
	"toggleBtnBound": `SessionPicker_toggleBtnBound__4hJpI`,
	"toggleBtnRunning": `SessionPicker_toggleBtnRunning__fcG9v`,
	"label": `SessionPicker_label__7scNR`,
	"runningElapsed": `SessionPicker_runningElapsed__YbohB`,
	"chevron": `SessionPicker_chevron__cZWNd`,
	"catIcon": `SessionPicker_catIcon__xtXdM`,
	"dropdown": `SessionPicker_dropdown__OyyTy`,
	"sp-fade-in": `SessionPicker_sp-fade-in__M1MsA`,
	"group": `SessionPicker_group__Sd0Rm`,
	"groupTitle": `SessionPicker_groupTitle__VeGoX`,
	"option": `SessionPicker_option__PwP42`,
	"optionCurrent": `SessionPicker_optionCurrent__QumQl`,
	"optionLabel": `SessionPicker_optionLabel__8gZ3i`,
	"optionSid": `SessionPicker_optionSid__QXtUC`,
	"optionConn": `SessionPicker_optionConn__uIduZ`,
	"optionStatus": `SessionPicker_optionStatus__1OOd4`,
	"status_idle": `SessionPicker_status_idle__0FCOU`,
	"status_running": `SessionPicker_status_running__vVtQL`,
	"status_cancelling": `SessionPicker_status_cancelling__b8hHi`,
	"empty": `SessionPicker_empty__mJ+Os`,
	"projectFooter": `SessionPicker_projectFooter__VsBoY`,
	"connType": `SessionPicker_connType__H40Co`,
	"connTypeDot": `SessionPicker_connTypeDot__zBF55`
};
export default ___CSS_LOADER_EXPORT___;
